import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import ScrollToTop from './ScrollToTop';
import FullScreenOverlay from '../../shared/components/FullScreenOverlay';
import { LoadingProvider, useLoading } from '../../providers/LoadingProvider';
import { ModalProvider } from '../../providers/ModalContext';

ReactGA.initialize('UA-167833993-2');
require('dotenv').config();

const AppShell = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const { active } = useLoading();

  useEffect(() => {
    window.addEventListener('load', () => {
      setIsLoading(false);
      setTimeout(() => setIsLoaded(true), 500);
    });
  }, []);

  return (
    <BrowserRouter>
      <FullScreenOverlay active={active} />
      <ScrollToTop>
        {!isLoaded && (
          <div className={`load${isLoading ? '' : ' loaded'}`}>
            <div className="load__icon-wrap">
              <svg className="load__icon">
                <path
                  fill="#2A2E4F"
                  d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                />
              </svg>
            </div>
          </div>
        )}
        <div>
          <Router />
        </div>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default function App() {
  return (
    <LoadingProvider>
      <ModalProvider>
        <AppShell />
      </ModalProvider>
    </LoadingProvider>
  );
}
